<div class="main-register">  
    <div class="container">
        <div class="left-section">
            <img src="/assets/logo_2x.png" alt="Logo de Conectio" class="logo">
            <h2>{{ 'companyRegister.title' | translate }} <span class="highlight">Conectio</span></h2>
            <p>{{ 'companyRegister.subtitle' | translate }}</p>
            <p>{{ 'companyRegister.description' | translate }}</p>
            <h3>{{ 'companyRegister.benefits.title' | translate }}</h3>
            <ul>
                <li>{{ 'companyRegister.benefits.accompaniment' | translate }}</li>
                <li>{{ 'companyRegister.benefits.match' | translate }}</li>
                <li>{{ 'companyRegister.benefits.access' | translate }}</li>
                <li>{{ 'companyRegister.benefits.advice' | translate }}</li>
                <li>{{ 'companyRegister.benefits.ally' | translate }}</li>
            </ul>
        </div>
        <div class="right-section">
            <h2>{{ 'companyRegister.form.title' | translate }}</h2>
            <form [formGroup]="registerForm" (ngSubmit)="register()" autocomplete="off">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyRegister.form.companyName' | translate }}</mat-label>
                    <input matInput type="text" formControlName="name" name="name" required>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyRegister.form.email' | translate }}</mat-label>
                    <input matInput type="email" formControlName="email" name="email_login" required>
                </mat-form-field>

                <div class="phone-row">
                    <mat-form-field appearance="fill" class="dial-code">
                        <mat-label>{{ 'companyRegister.form.countryCode' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="country"
                            [matAutocomplete]="countryAuto"
                            autocomplete="off"
                            required>
                        <mat-autocomplete
                            #countryAuto="matAutocomplete"
                            class="country-autocomplete-panel"
                            [panelWidth]="340"
                            [displayWith]="displayCountry"
                            (optionSelected)="onCountrySelected($event.option.value)">
                            <mat-option
                                *ngFor="let c of filteredCountries$ | async; trackBy: trackByCode"
                                [value]="c">
                                <img
                                    [src]="'/assets/extension-chrome/country-flags/' + c.code + '.svg'"
                                    [alt]="c.code"
                                    class="flag">
                                <span class="country-name">{{ countryName(c) }}</span>
                                <span class="dial">{{ c.dialCode }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="phone-number">
                        <mat-label>{{ 'companyRegister.form.phone' | translate }}</mat-label>
                        <input
                            matInput
                            type="tel"
                            inputmode="numeric"
                            formControlName="phone"
                            name="phone_login"
                            required>
                    </mat-form-field>
                </div>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyRegister.form.password' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password" name="password_login" required>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'companyRegister.form.linkedinUrl' | translate }}</mat-label>
                    <input matInput type="url" formControlName="linkedin_url" name="linkedin_url">
                </mat-form-field>

                <div *ngIf="errorMessage" class="error-message">
                    {{ errorMessage }}
                </div>
                <mat-checkbox formControlName="terms" required>
                    {{ 'companyRegister.form.terms' | translate }}
                </mat-checkbox>
                <br>

                <button mat-raised-button color="primary" type="submit" [disabled]="isLoading" *ngIf="!isLoading">
                    {{ 'companyRegister.form.register' | translate }}
                </button>
                <div *ngIf="isLoading" style="display: inline-block; margin-left: 10px;">
                    <img src="/assets/spinner.gif" [alt]="'companyRegister.form.loading' | translate" style="width: 40px; height: 40px;">
                </div>
                <a href="/company/login?redirect_to_buy={{ redirect_to_buy ? 1 : 0 }}" class="recover-link">{{ 'companyRegister.form.hasAccount' | translate }}</a>
            </form>
        </div>
    </div>
</div>